// // utils/timeUtils.ts
// import dayjs from 'dayjs';
// import relativeTime from 'dayjs/plugin/relativeTime';
// dayjs.extend(relativeTime);
// // 当时间小于1小时是，返回发布于**分钟前;
// // 当时间大于1小时且小于24小时时，返回发布于**小时前;
// // 当时间大于24小时且小于等于3天时，返回发布于**天前;
// // 当时间大于3天且属于半年内或者同一年份时，返回发布于MM-DD;
// // 当时间大于等于半年以上且不在同一年份时，返回发布于YYYY-MM
// export const formatTime = (timestamp: string | number | Date): string => {
//     // 调试信息
//     // console.log('原始时间:', timestamp);
//     // console.log('原始时间类型:', typeof timestamp);
    
//     // 解析时间
//     const targetTime = dayjs(timestamp);
//     const now = dayjs();
    
//     // console.log('解析后的时间:', targetTime.format('YYYY-MM-DD HH:mm:ss'));
//     // console.log('解析是否有效:', targetTime.isValid());
//     // console.log('当前时间:', now.format('YYYY-MM-DD HH:mm:ss'));
    
//     // 检查时间差
//     const diffInMinutes = now.diff(targetTime, 'minute');
//     const diffInHours = now.diff(targetTime, 'hour');
//     const diffInDays = now.diff(targetTime, 'day');
    
//     // console.log('时间差 - 分钟:', diffInMinutes);
//     // console.log('时间差 - 小时:', diffInHours);
//     // console.log('时间差 - 天:', diffInDays);
    
//     // 继续原有逻辑...
//     if (diffInMinutes < 1) return '发布于刚刚';
//     if (diffInMinutes < 60) return `发布于${diffInMinutes}分钟前`;
//     if (diffInHours < 24) return `发布于${diffInHours}小时前`;
//     if (diffInDays <= 3) return `发布于${diffInDays}天前`;

//     const isWithinHalfYear = diffInDays <= 180;
//     const isSameYear = now.isSame(targetTime, 'year');

//     if (isWithinHalfYear && isSameYear) {
//         return `发布于${targetTime.format('MM-DD')}`;
//     }

//     return `发布于${targetTime.format('YYYY-MM')}`;
// };
// utils/timeUtils.ts
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

/**
 * 格式化时间为相对时间（如：5分钟前、3天前等）
 */
export const formatTime = (timestamp, showPrefix = true) => {
    const targetTime = dayjs(timestamp);
    const now = dayjs();
    
    const diffInMinutes = now.diff(targetTime, 'minute');
    const diffInHours = now.diff(targetTime, 'hour');
    const diffInDays = now.diff(targetTime, 'day');
    
    let result = '';
    
    if (diffInMinutes < 1) result = '刚刚';
    else if (diffInMinutes < 60) result = `${diffInMinutes}分钟前`;
    else if (diffInHours < 24) result = `${diffInHours}小时前`;
    else if (diffInDays <= 3) result = `${diffInDays}天前`;
    else {
        const isWithinHalfYear = diffInDays <= 180;
        const isSameYear = now.isSame(targetTime, 'year');

        if (isWithinHalfYear && isSameYear) {
            result = targetTime.format('MM-DD');
        } else {
            result = targetTime.format('YYYY-MM');
        }
    }
    
    return showPrefix ? `发布于${result}` : result;
};

/**
 * 格式化日期时间（带时分）
 * 今年：MM-DD HH:mm
 * 非今年：YYYY-MM-DD HH:mm
 */
export const formatDateTime = (timestamp) => {
    const targetTime = dayjs(timestamp);
    const now = dayjs();
    
    const isCurrentYear = now.isSame(targetTime, 'year');
    
    if (isCurrentYear) {
        return `${targetTime.format('MM-DD HH:mm')}`;
    } else {
        return `${targetTime.format('YYYY-MM-DD HH:mm')}`;
    }
};

export default {
    formatTime,
    formatDateTime
};